import { getServiceTicketOptions, createServiceTicket, addTicketComment, getTicketList, getTicketDetails } from "../../api";
import useTicketStore from "../stores/ticket";

export const fetchTicketOptions = async () => {
  try {
    const response = await getServiceTicketOptions();
    if (response.status) {
      const store = useTicketStore.getState();
      store.setOptions({
        ...store.options,
        owner_groups: response.data.owner_groups || [],
        problem_types: response.data.problem_types || [],
        statuses: response.data.statuses || []
      });
    }
    return response;
  } catch (error) {
    console.error("Error fetching ticket options:", error);
    throw error;
  }
};

export const createTicket = async (data) => {
  try {
    // If data is FormData, send as is, otherwise send as JSON
    const config = data instanceof FormData ? {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    } : {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    
    const response = await createServiceTicket(data, config);
    return response;
  } catch (error) {
    console.error("Error creating ticket:", error);
    throw error;
  }
};

export const addComment = async (data) => {
  try {
    // If data is FormData, send as is, otherwise send as JSON
    const config = data instanceof FormData ? {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    } : {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    const response = await addTicketComment(data, config);
    return response;
  } catch (error) {
    console.error("Error adding comment:", error);
    throw error;
  }
};

export const fetchTickets = async (filters = {}) => {
  try {
    const store = useTicketStore.getState();

    const response = await getTicketList({
      page: filters.page || store.currentPage,
      search: filters.search || store.searchQuery,
      status: filters.status || store.ticketFilterSearchQuery.status,
      problem_type: filters.problemType || store.ticketFilterSearchQuery.problemType,
      owner_group: filters.ownerGroup || store.ticketFilterSearchQuery.ownerGroup,
      dba: filters.dba || store.ticketFilterSearchQuery.dba,
      created: filters.created || store.ticketFilterSearchQuery.created,
      sort_field: filters.sortBy,
      sort_direction: filters.sortValue?.toLowerCase(),
      ...(store.merchantTicketScopePowerappId != null && {
        powerapp_id: store.merchantTicketScopePowerappId,
      }),
    });

    if (response.status) {
      if (response.data && response.data.length > 0) {
        const tickets = response.data.map(ticket => ({
          key: ticket.id,
          id: ticket.id,
          dba: ticket.dba,
          mid: ticket.mid,
          processor: ticket.processor,
          processorLogo: ticket.processor ? `/img/${ticket.processor.toLowerCase().replace(/\s+/g, '')}/logo-solid.png` : null,
          created_at: new Date(ticket.created_at).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }),
          last_comment: new Date(ticket.last_comment).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }),
          owner_group: ticket.owner_group,
          problem_type: ticket.problem_type,
          assigned_to: ticket.assigned_to,
          status: ticket.status
        }));
        store.setTickets(tickets);
      } else {
        store.setTickets([]);
      }
      if(response.meta) {
        store.setPageCount(response.meta.last_page);
        store.setCurrentPage(response.meta.current_page);
        store.setTotalItems(response.meta.total);
        store.setItemsPerPage(response.meta.per_page);
      }
    } else {
      store.setTickets([]);
      store.setPageCount(1);
      store.setCurrentPage(1);
      store.setTotalItems(0);
      store.setItemsPerPage(0);
    }

    return response;
  } catch (error) {
    console.error("Error fetching tickets:", error);
    // Set empty state on error
    const store = useTicketStore.getState();
    store.setTickets([]);
    store.setPageCount(1);
    store.setCurrentPage(1);
    store.setTotalItems(0);
    store.setItemsPerPage(0);
    throw error;
  }
};

export const fetchTicketDetails = async (id) => {
  try {
    const response = await getTicketDetails({ id });
    if (response.status) {
      const store = useTicketStore.getState();
      store.setSelectedTicket({
        ...response.data,
        key: response.data.id,
        ticket: response.data.id,
        dba: response.data.dba,
        mid: response.data.mid,
        processor: response.data.processor,
        processorLogo: response.data.processor ? `/img/${response.data.processor.toLowerCase().replace(/\s+/g, '')}/logo-solid.png` : null,
        created_at: response.data.created_at,
        last_comment: response.data.last_comment,
        owner_group: response.data.owner_group,
        problem_type: response.data.problem_type,
        rep: response.data.assigned_to,
        status: response.data.status,
        comments: response.data.comments || []
      });
    }
    return response;
  } catch (error) {
    console.error("Error fetching ticket details:", error);
    throw error;
  }
};